import type { CertGenParams } from '@yandex-int/k-common';
import { format } from 'date-fns';

interface Props extends CertGenParams {
    slug:
        | 'KINFU'
        | 'AstraLinuxAutumn2025'
        | 'NewJournalAutumn2025'
        | 'LegalBasisAutumn2025'
        | 'EmotionalBurnoutAutumn2025'
        | 'SchoolBullyingAutumn2025'
        | 'AssessmentForTrainingAutumn2025'
        | 'TeacherReserveCandidate'
        | 'TeacherReserveExpertAutumn2025'
        | 'TeacherReserveIncludeInKRAutumn2025'
        | 'StudentDiagInfAutumn2025'
        | 'TRMENTOR'
        | 'TeacherReserveProjectActivities2026'
        | 'TeacherReserveGamesAtSchool2026'
        | 'TeacherReserveCryptography2026'
        | 'StudentDiagInfSpring2026';
    issue_date?: string;
}

const formatedData = (date?: string) => (date ? format(new Date(date), 'dd.MM.yyyy') : '2025');
const formatedDataYear = (date?: string) => (date ? format(new Date(date), 'yyyy') : '2025');

/** Шаблон для большинства сертов 2025 года */
// eslint-disable-next-line complexity
export const BaseCert2025 = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    slug,
    issue_date: issueDate,
}: Props) => {
    let image = '';
    let awardDescription = '';
    let awardName = 'Сертификат';
    let schoolNameMessage = `получает педагог <br/> ${schoolName ? `${schoolName}` : ''}`;
    let textColor = '#000000E5';
    let titleMeta = 'Сертификат';

    let extraTags: string[] = [];

    switch (slug) {
        case 'KINFU':
            titleMeta = 'Сертификат за участие в Конференции Яндекс Учебника';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/6887102/2a0mekqFXfU9ACrwf5b14/orig';
            awardDescription = 'за участие в Конференции Яндекс Учебника<br/>для учителей информатики — 2025';
            break;
        case 'AstraLinuxAutumn2025':
            titleMeta = 'Сертификат за прохождение курса «Astra Linux»';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5406199/e5MzVw7zeKY7dzoC38Utp/orig';
            awardDescription = 'за прохождение курса «Astra Linux»<br/>в рамках программы «Кадровый резерв»';
            break;
        case 'NewJournalAutumn2025':
            titleMeta = 'Сертификат за прохождение курса «Анализ данных из журнала Яндекс Учебника»';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5406199/vtwqP2jjC3cx0iOVIN1Tk/orig';
            awardDescription =
                'за прохождение курса «Анализ данных<br/>из журнала Яндекс Учебника» в рамках<br/>программы «Кадровый резерв»';
            break;
        case 'LegalBasisAutumn2025':
            titleMeta = 'Сертификат за прохождение курса «Правовые основы педагогической деятельности»';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5623482/1qqaZfL7kg89pDDFQx0qu/orig';
            awardDescription =
                'за прохождение курса «Правовые основы<br/>педагогической деятельности» в рамках<br/>программы «Кадровый резерв»';
            break;
        case 'EmotionalBurnoutAutumn2025':
            titleMeta = 'за прохождение курса «Эмоциональное выгорание у педагогов»';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/6887102/njdusPAouPIkK1iSl43Mo/orig';
            awardDescription =
                'за прохождение курса «Эмоциональное<br/>выгорание у педагогов» в рамках<br/>программы «Кадровый резерв»';
            break;
        case 'SchoolBullyingAutumn2025':
            titleMeta = 'Сертификат за прохождение курса «Конфликты и травля в школьной среде»';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5406199/7fZluX7NUfsUFTsZ2K4aM/orig';
            awardDescription =
                'за прохождение курса «Конфликты и травля<br/>в школьной среде» в рамках программы<br/>«Кадровый резерв»';
            break;
        case 'AssessmentForTrainingAutumn2025':
            titleMeta = 'Сертификат за прохождение курса «Оценивание для обучения»';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/6887102/nby4r4pGy5c3GbU2UvqlA/orig';
            awardDescription =
                'за прохождение курса «Оценивание<br/>для обучения» в рамках программы<br/>«Кадровый резерв»';
            break;
        case 'TeacherReserveCandidate':
            titleMeta = 'Сертификат подтверждает участие в программе профессионального развития «Кадровый резерв»';
            image =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5623482/0309b76154ec2a0a6d00cb431009c3ca/orig';
            schoolNameMessage = `подтверждает, что педагог <br/> ${schoolName ? `${schoolName}` : ''}`;
            awardDescription = 'участвует в программе профессионального<br/>развития «Кадровый резерв»';
            extraTags = [formatedData(issueDate)];
            break;
        case 'TeacherReserveExpertAutumn2025':
            titleMeta = 'Сертификат подтверждает переход в состав Кадрового резерва';
            schoolNameMessage = `подтверждает, что педагог <br/> ${schoolName ? `${schoolName}` : ''}`;
            image =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5623482/483247c3e29ea4853db1b8e2f3ef5a7e/orig';
            awardDescription =
                'набрав первые 100 баллов в программе<br/>профессионального развития компании «Яндекс»,<br/>переходит в состав Кадрового резерва';
            extraTags = [formatedData(issueDate)];
            break;
        case 'TeacherReserveIncludeInKRAutumn2025':
            titleMeta = 'Сертификат подтверждает, что педагог является финалистом программы Кадрового резерва';
            schoolNameMessage = `подтверждает, что педагог <br/> ${schoolName ? `${schoolName}` : ''}`;
            image =
                'https://avatars.mds.yandex.net/get-schoolbook-images/16309750/9bb215c458a3bcbc0522880f37121fd7/orig';
            awardDescription =
                'является финалистом программы<br/>профессионального развития<br/>«Кадровый резерв» 2025/26 учебного года';
            extraTags = [formatedData(issueDate)];
            break;
        case 'StudentDiagInfAutumn2025':
            awardName = 'Благодарность';
            titleMeta = 'Благодарность за проведение осенней диагностики по информатике';
            textColor = '#FFFFFFE5';
            image =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5406199/0b984656f906eff752e14bc42a3294c8/orig';
            awardDescription =
                'за проведение осенней диагностики по информатике. Благодаря вам ученики лучше готовы к освоению знаний в этом году.';
            break;
        case 'TRMENTOR':
            extraTags = [`${formatedDataYear(issueDate)} г.`, 'г. Москва'];
            image =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5623482/e1b660ed7d955e119c3cebb501569cdc/orig';
            awardDescription =
                'за успешное прохождение Школы наставников по программе профессионального развития </br> Кадровый резерв </br> учителей информатики';
            break;
        case 'TeacherReserveProjectActivities2026':
            titleMeta = 'Сертификат за прохождение курса «Проектная деятельность»';
            image =
                'https://avatars.mds.yandex.net/get-schoolbook-store/13953640/project_1.png-fa230db1-3d82-4c1a-a286-a3285b7d0ac6/orig';
            awardDescription = 'за прохождение курса «Проектная деятельность» в рамках программы «Кадровый резерв»';
            break;
        case 'TeacherReserveGamesAtSchool2026':
            titleMeta = 'Сертификат за прохождение курса «Игры в школе»';
            image =
                'https://avatars.mds.yandex.net/get-schoolbook-store/13953640/games_1.png-59b635be-59e8-47b5-969a-10a7712ec8da/orig';
            awardDescription = 'за прохождение курса «Игры в школе» в рамках программы «Кадровый резерв»';
            break;
        case 'TeacherReserveCryptography2026':
            titleMeta = 'Сертификат за прохождение курса «Криптография»';
            image =
                'https://avatars.mds.yandex.net/get-schoolbook-store/14008290/crypt_1.png-94e44368-672c-44e7-bb30-ab11fc4f632d/orig';
            awardDescription = 'за прохождение курса «Криптография» в рамках программы «Кадровый резерв»';
            break;
        case 'StudentDiagInfSpring2026':
            awardName = 'Благодарность';
            titleMeta = 'Благодарность за проведение весенней диагностики по информатике';
            textColor = '#FFFFFFE5';
            image =
                'https://avatars.mds.yandex.net/get-schoolbook-store/14008290/blagodarnost_uchitelyam.png-2f0dfba9-7402-42e6-8278-be20bbedd567/orig';
            awardDescription =
                'за проведение весенней диагностики по информатике. Благодаря вашей работе ученики могут увидеть, как они освоили программу в этом учебном году.';
            break;
    }

    return `<!DOCTYPE html>
    <html lang="ru">
        <head>
            <title>${titleMeta}</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <style>
                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff') format('woff');
                    font-weight: 300;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff') format('woff');
                    font-weight: 400;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff') format('woff');
                    font-weight: 500;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff') format('woff');
                    font-weight: bold;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Display';
                    font-weight: bold;
                    font-style: normal;
                    font-stretch: normal;

                    src: url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff2') format('woff2'),
                        url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff') format('woff');
                }

                @font-face {
                    font-family: 'YS Display';
                    font-weight: 800;
                    font-style: normal;
                    font-stretch: normal;

                    src: url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff2') format('woff2'),
                        url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff') format('woff');
                }

                @page {
                    size: 210mm 297mm;
                    margin: 0;
                    padding: 0;
                }

                @media print {
                    html,
                    body {
                        width: 210mm;
                        height: 297mm;

                        box-sizing: border-box;
                    }
                }

                html {
                    position: relative;

                    margin: 0;
                    padding: 0;


                    --text-color: ${textColor};
                }

                body {
                    margin: 0;

                    color: var(--text-color);

                    font-family: 'YS Text', sans-serif;
                }

                .page {
                    position: relative;

                    overflow: hidden;

                    box-sizing: border-box;

                    width: 210mm;
                    height: 297mm;

                    background: var(--background-color);

                    page-break-after: always;
                }

                .page__background {
                    position: absolute;

                    width: 100%;
                    height: 100%;

                    overflow: hidden;

                    display: flex;

                    z-index: 1;
                }

                .page__content {
                    height: 100%;
                    width: 100%;
                }

                .content {
                    position: relative;
                    box-sizing: border-box;

                    display: flex;

                    z-index: 5;
                    flex-direction: column;

                    width: calc(210 / 595 * 369mm);

                    padding-left: calc(210 / 595 * 24mm);
                    padding-bottom: calc(210 / 595 * 24mm);

                    color: var(--text-color);
                }

                .empty-space {
                    height: 46.5%
                }

                .content_title {
                    font-size: calc(297 / 842 * 48mm);
                    font-weight: 400;
                    line-height: calc(297 / 842 * 52mm);
                }


                .personal-info__school {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12pt;
                    line-height: 16.8pt;
                    color: var(--text-color);
                    margin-top: calc(297 / 842 * 8mm);
                }

                .personal-info__name {
                    font-size: 32pt;
                    line-height: 36pt;
                    margin-bottom: calc(297 / 842 * 34mm);

                }

                 .award-description {
                    font-weight: 400;
                    font-size: 16pt;
                    line-height: 24pt;
                }

                .cert-info {
                    position: relative;
                    margin-top: calc(297 / 842 * 16mm);
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    flex-grow: 1;
                }

                .cert-info__meta {
                    display: flex;
                    flex-direction: column;
                    justify-content: start;
                    gap: 3.29pt;
                    top: 5pt;
                    right: -217pt;
                    position: absolute;
                    width: 164pt;
                    height: 87pt;
                }

                .cert-info__meta__tag {
                    font-size: 12pt;
                    box-sizing: border-box;
                    padding: 5pt 10pt;
                    display: flex;
                    height: 27pt;
                    width: max-content;
                    align-items: center;
                    border-radius: 8pt;
                    box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.05);;
                }
            </style>
        </head>
        <body>
            <div class="page">
                <div class="page__background">
                    <img alt="" src="${image}" />
                </div>
                <div class="page__content content">
                    <div class="empty-space"></div>
                    <div class="cert-info">
                        <div class="cert-info__meta">
                            ${extraTags?.map((tag) => `<div class="cert-info__meta__tag">${tag}</div>`).join('')}
                        </div>
                        <div>
                            <div class="content_title">${awardName}</div>
                            <div class="personal-info__school">${schoolNameMessage}</div>
                        </div>
                        <div class="personal-info__name">
                                ${lastName ? `${lastName}` : ''}<br />
                                ${firstName ? `${firstName}` : ''}<br />
                                ${middleName ? `${middleName}` : ''}
                        </div>
                        <div class="award-description">${awardDescription}</div>
                    </div>
                </div>
            </div>
        </body>
    </html>
    `;
};
